import {Link} from "react-router-dom";
import PrimaryButton from "./PrimaryButton";
import {inject, observer} from "mobx-react";

function WaitingListBanner({DeviceStore, theme}){

  const {t} = DeviceStore;

  return (<div className="card text-sm mb-4 p-4 md:px-6 flex justify-between items-center">
    <div>
      <h2 className="font-bold">{t('sold_out')}?</h2>
      <p className="mr-6">
        {t('waiting_list_description')}
      </p>
    </div>
    <Link className="btn" to={'waiting-list'}>
      <PrimaryButton theme={theme} label={t('subscribe')}/>
    </Link>
  </div>)
}

export default inject('DeviceStore')(observer(WaitingListBanner));
